import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DID } from 'voxloud-types/dist/models';

import { NumberInfoPopupComponent } from '../number-info-popup/number-info-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'gdp-numbers-table',
  templateUrl: './numbers-table.component.html',
  styleUrls: ['./numbers-table.component.scss']
})
export class NumbersTableComponent implements OnInit {
  @Input() dids: DID[];
  @Input() loading: boolean;
  @Input() pageSize: number;
  public locale: string;
  constructor(
    private modalService: NgbModal,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.locale = `${this.translate.currentLang}-${this.translate.currentLang.toUpperCase()}`;
    this.translate.onLangChange.subscribe(l => {
      this.locale = `${l.lang}-${l.lang.toUpperCase()}`;
    });
  }

  get loadingLinesArray() {
    return new Array(this.pageSize);
  }

  openFullInfoPopup(did: DID) {
    const modal = this.modalService.open(NumberInfoPopupComponent, {
      size: 'lg'
    });
    modal.componentInstance.did = did;
  }

}
